import React from 'react'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import DeleteIcon from '@mui/icons-material/Delete'

const SommetDistance = ({ nodes, edges, deleteNode, deleteEdge }) => {
    return (
        <div className="w-full bg-gray-100 p-4 rounded" style={{ maxWidth: '100%', overflow: 'hidden' }}>
            {/* Tableau des Sommets */}
            <h3 className="font-medium mb-2">Sommets :</h3>
            {nodes.length === 0 ? (
              <p className="text-gray-500">Aucun sommet créé</p>
            ) : (
              <div style={{ overflowX: 'auto', maxWidth: '100%', WebkitOverflowScrolling: 'touch' }}>
                <table className="w-full" style={{ whiteSpace: 'nowrap' }}>
                  <tbody>
                    {Array.from({ length: Math.ceil(nodes.length / 21) }).map((_, rowIndex) => (
                      <tr key={`node-row-${rowIndex}`}>
                        {Array.from({ length: 21 }).map((_, colIndex) => {
                          const nodeIndex = rowIndex * 21 + colIndex
                          const node = nodes[nodeIndex]
                          return node ? (
                            <td key={node.id} className="p-1 border">
                              <div className="flex justify-between items-center p-1">
                                <span>{node.name}</span>
                                <Tooltip title="Supprimer">
                                  <IconButton onClick={() => deleteNode(node.id)} size="small" color="error">
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </div>
                            </td>
                          ) : <td key={`empty-${colIndex}`} className="p-1 border"></td>;
                        })}
                      </tr>
                    ))}
                    </tbody>
                </table>
              </div>
            )}
            <br />
            {/* Tableau des Arêtes */}
            <h3 className="font-medium mb-2">Distances :</h3>
            {edges.length === 0 ? (
              <p className="text-gray-500">Aucune distance créée</p>
            ) : (
              <div style={{ overflowX: 'auto', maxWidth: '100%', WebkitOverflowScrolling: 'touch' }}>
                <table className="w-full" style={{ whiteSpace: 'nowrap' }}>
                  <tbody>
                    {Array.from({ length: Math.ceil(edges.length / 12) }).map((_, rowIndex) => (
                    <tr key={`edge-row-${rowIndex}`}>
                      {Array.from({ length: 12 }).map((_, colIndex) => {
                        const edgeIndex = rowIndex * 12 + colIndex
                        const edge = edges[edgeIndex]
                        return edge ? (
                          <td key={edge.id} className="p-1 border">
                            <div className="flex justify-between items-center p-1">
                              <span className="text-sm">
                                {nodes.find(n => n.id === edge.source)?.name} →
                                {nodes.find(n => n.id === edge.target)?.name} ({edge.weight})
                              </span>
                              <Tooltip title="Supprimer">
                                <IconButton onClick={() => deleteEdge(edge.id)} size="small" color="error">
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </div>
                          </td>
                        ) : <td key={`empty-${colIndex}`} className="p-1 border"></td>;
                      })}
                      </tr>
                    ))}
                    </tbody>
                </table>
              </div>
            )}

          </div>
    )
}

export default SommetDistance